<template>
  <v-card flat>
    <v-row
      no-gutters
      class="px-4"
    >
      <v-col
        v-if="!hideOffice"
        cols="12"
        class="px-3"
        :sm="6"
        :md="4"
      >
        <WBDOfficeSelectorFilter
          :remote-list="[]"
          :label="'Поиск объектов'"
          :remote-selected-list-list="''"
          @onOfficeSelectorFilterChange="onOfficeSelectorFilterChange"
        />
      </v-col>
    </v-row>
  </v-card>
</template>

<script>

import WBDOfficeSelectorFilter from '@/components/common/filter/office-selector-filter'

export default {
  name: 'WBDStatementPageFilter',
  components: {
    // WDatePicker,
    WBDOfficeSelectorFilter,
  },
  props: {
    hideOffice: {
      type: Boolean,
      default: false
    },
    statementPageFilter: {
      type: Object,
      default: () => ({
        office: null,
      })
    }
  },
  data: () => ({
    searchQuery: '',
    filteredOfficeList: '',
    remoteList: [],
    loading: true,
  }),
  computed: {

  },
  watch: {
    statementPageFilter: {
      handler (val) {
        for (const [key, value] of Object.entries(val)) {
          if (this.statementPageFilter[key] !== value) {
            this.statementPageFilter[key] = value
          }
        }
      },
      deep: true,
    },
  },
  created () {
    this.eventsBus.$on(this.eventNames.PAGE_STATEMENT_RESET, () => {
      this.resetAll()
      this.resetAll()
    })
  },
  methods: {
    onOfficeSelectorFilterChange (data, office) {
      this.statementPageFilter.office = office
    },
    resetAll () {
      this.eventsBus.$emit(this.eventNames.OFFICE_LIST_FILTER_RESET)
    },
  }
}
</script>

